<template>
  <div class="grid grid-cols-1 mx-5 my-5 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-3 gap-6">
    <BoardCard title="Баланс">
      <BalanceBlock></BalanceBlock>
    </BoardCard>
  </div>
  <div class="grid grid-cols-1 mx-5 my-5 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1 2xl:grid-cols-1 gap-6">
    <BoardCard title="История">
      <BalanceTransactions/>
    </BoardCard>
  </div>
</template>

<script>
import BoardCard from "@/components/BoardCard.vue";
import BalanceBlock from "@/components/block/BalanceBlock.vue";
import BalanceTransactions from "@/components/block/BalanceTransactions.vue";

export default {
  name: 'BalancePage',
  components: {BoardCard, BalanceBlock, BalanceTransactions},
  data() {
    return {
      balance: null
    }
  },
  methods: {
    loadBalance() {
      //
    }
  }
}
</script>

<style scoped>

</style>